
	<div
		*ngIf="OBJ_form_group?.value?.latitude && OBJ_form_group?.value?.longitude"
		class="form-group"
		[formGroup]="OBJ_form_group">
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}"></label>
		<div class="col-lg-8">
			<div #googleMap style='width:100%;height:300px'></div>
		</div>
	</div>
  